import { memo } from "react";

interface OnlineIndicatorProps {
  isOnline: boolean;
  size?: "sm" | "md";
}

const OnlineIndicator = memo(({ isOnline, size = "sm" }: OnlineIndicatorProps) => {
  const sizeClasses = size === "sm" ? "w-2.5 h-2.5" : "w-3 h-3";
  
  return (
    <span 
      className={`absolute bottom-0 right-0 ${sizeClasses} rounded-full border-2 border-card ${
        isOnline ? "bg-green-500" : "bg-muted-foreground"
      }`}
    />
  );
});

OnlineIndicator.displayName = "OnlineIndicator";

export default OnlineIndicator;
